import { FormFieldData } from "modules/forms";
import { ObservationLocationTypeEnum } from "shared/enums/ObservationLocationType.enum";
import { GoodPracticeEntity } from "shared/types/domain/GoodPracticeEntity";
import { IMapper } from "shared/types/IMapper";
import { keysAreEqual } from "shared/utils/equality.utils";
import { CreateGoodPracticeRequest } from "../mutations/create-good-practice.mutations.types";
import { ObservationrecordOriginEnum } from "shared/enums/ObservationrecordOrigin.enum";
import i18next from 'i18next';
import { ObservationLanguageEnum } from "shared/enums/ObservationLanguageEnum";

export class CreateGoodPracticeRequestMapper implements IMapper<FormFieldData<GoodPracticeEntity>, CreateGoodPracticeRequest> {
    map(entity: FormFieldData<GoodPracticeEntity>): CreateGoodPracticeRequest {
        return {
            companyId: entity.companyId,
            locationType: entity.locationType.toUpperCase(),
            depotPcId: entity.depotPcId,
            customerSiteName: keysAreEqual(entity.locationType, ObservationLocationTypeEnum.CustomerSite) ? entity.customerSiteName : null,
            locationDescription: keysAreEqual(entity.locationType, ObservationLocationTypeEnum.SunbeltDepot) ? null : entity.locationDescription,
            locationLatitude: keysAreEqual(entity.locationType, ObservationLocationTypeEnum.Other) ? entity.locationLatitude : null,
            locationLongitude: keysAreEqual(entity.locationType, ObservationLocationTypeEnum.Other) ? entity.locationLongitude : null,
            observationCategoryId: entity.observationCategoryId,
            whatHappened: entity.whatHappened,
            whoShouldBeCommended: entity.whoShouldBeCommended,
            reporterType: entity.reporterType.toUpperCase(),
            anonymousEntry: entity.anonymousEntry ?? false,
            contactName: entity.reporterContactName,
            contactPhoneNumber: entity.reporterPhoneNumber,
            contactEmail: entity.reporterEmail,
            createdFrom: ObservationrecordOriginEnum.WebApp,
            selectedLanguage: ObservationLanguageEnum[i18next.language.toUpperCase() as keyof typeof ObservationLanguageEnum]
        }
    };
}